import type { MePayload, ViewKey } from "../types";
import { apiGet } from "./api";

export function legacyButtonForView(view: ViewKey): HTMLButtonElement | null {
  return document.querySelector<HTMLButtonElement>(`#nav button[data-view="${view}"]`);
}

export async function navigateWithFallback(view: ViewKey): Promise<void> {
  if (window.tojIms?.navigate) {
    await window.tojIms.navigate(view);
    return;
  }
  const button = legacyButtonForView(view);
  if (!button) throw new Error(`Screen is not available: ${view}`);
  button.click();
}

export async function openHelpWithFallback(): Promise<void> {
  if (window.tojIms?.openHelp) {
    await window.tojIms.openHelp();
    return;
  }
  document.querySelector<HTMLButtonElement>("#globalHelp")?.click();
}

export async function signOutWithFallback(): Promise<void> {
  if (window.tojIms?.signOut) {
    await window.tojIms.signOut();
    return;
  }
  const me = await apiGet<MePayload>("/api/me");
  await fetch("/api/logout", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      ...(me.csrf_token ? { "X-CSRF-Token": me.csrf_token } : {})
    },
    body: "{}"
  });
  window.location.reload();
}
